import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";


const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("token");
         navigate("/");
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>You have been logged out.</h2>
      <p>Redirecting to login...</p>
    </div>
  );
};

export default Logout;
